var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    className: "flip-rtl css-i42ndf-AdsIcon e2r2qy42",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.11 5.34A2 2 0 0 1 42 7v33.36a2 2 0 0 1-2.7 1.87l-7.88-2.97A9.89 9.89 0 0 1 23.65 43a9.77 9.77 0 0 1-9.82-10.38L8 30.42v1.24a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V16.34a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.78L39.23 5.15a2 2 0 0 1 1.88.19ZM8 22.44v3.7l30 11.33V10L8 22.45Zm9.87 11.7a5.91 5.91 0 0 0 9.47 3.57l-9.47-3.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/ads.903f34d5ccce53fc7c39821ef5db7296.svg";
export { ForwardRef as ReactComponent };